//
//  Word lists from various sources.
//  Used to create random file names for the exports
//
//  Sources (among others and random additions)
//  https://en.wikipedia.org/wiki/List_of_Crayola_crayon_colors
//  https://github.com/Atrox/haikunatorjs - BSD-3-Clause license
//
export const ADJECTIVES = [
  'adorable',
  'aged',
  'alert',
  'alien',
  'analog',
  'ancient',
  'animated',
  'aqua',
  'astro',
  'atomic',
  'autumn',
  'bashful',
  'batty',
  'bemused',
  'billowing',
  'bitter',
  'bittersweet',
  'black',
  'blue',
  'bold',
  'bouncing',
  'bright',
  'broad',
  'broken',
  'bronze',
  'calm',
  'carbon',
  'carefree',
  'caribbean',
  'chestnut',
  'cold',
  'cool',
  'cosmic',
  'crimson',
  'crunchy',
  'curly',
  'daffy',
  'daft',
  'damp',
  'dark',
  'dawn',
  'deep',
  'delicate',
  'descending',
  'divine',
  'dotted',
  'droll',
  'dry',
  'easy',
  'elastic',
  'electric',
  'elegant',
  'empty',
  'enigmatic',
  'epic',
  'excited',
  'fabulous',
  'falling',
  'fancy',
  'fatal',
  'flat',
  'floral',
  'fragrant',
  'frenzied',
  'fresh',
  'frolicsome',
  'frosty',
  'fuzzy',
  'gentle',
  'glassy',
  'glitter',
  'glorious',
  'green',
  'grunge',
  'hidden',
  'holy',
  'iced',
  'icy',
  'idiosyncratic',
  'imaginary',
  'impressive',
  'indigo',
  'ingenious',
  'inquisitive',
  'jolly',
  'joyful',
  'late',
  'lazy',
  'lingering',
  'little',
  'lively',
  'long',
  'lopsided',
  'loud',
  'lucky',
  'magic',
  'maroon',
  'marvelous',
  'maximum',
  'melodramatic',
  'metal',
  'middle',
  'misty',
  'mixed',
  'morning',
  'muddy',
  'mute',
  'mystic',
  'nameless',
  'neon',
  'new',
  'nifty',
  'noisy',
  'nonchalant',
  'odd',
  'old',
  'orange',
  'outlandish',
  'outrageous',
  'pacific',
  'patient',
  'permanent',
  'petite',
  'pixelated',
  'plain',
  'plucky',
  'polished',
  'proud',
  'purple',
  'quiet',
  'radical',
  'rambunctious',
  'rapid',
  'raspy',
  'red',
  'reflective',
  'restless',
  'rough',
  'round',
  'royal',
  'rusted',
  'rustic',
  'rusty',
  'scarlet',
  'scatterbrained',
  'shining',
  'shiny',
  'shocking',
  'shy',
  'silent',
  'silly',
  'small',
  'smokey',
  'snowy',
  'snug',
  'soft',
  'solitary',
  'sparkling',
  'spiked',
  'spiky',
  'spring',
  'square',
  'steel',
  'steep',
  'still',
  'sturdy',
  'summer',
  'super',
  'sweet',
  'throbbing',
  'thrumming',
  'tight',
  'tiny',
  'transparent',
  'tricky',
  'tropical',
  'twilight',
  'unassuming',
  'vibrant',
  'wandering',
  'warm',
  'weathered',
  'white',
  'wild',
  'winter',
  'wispy',
  'withered',
  'wondrous',
  'yellow',
  'yodeling',
  'young',
  'zealous',
];

export const NOUNS = [
  'adventure',
  'air',
  'alchemy',
  'art',
  'avocado',
  'band',
  'bar',
  'base',
  'basket',
  'bay',
  'beauty',
  'being',
  'belt',
  'bird',
  'bison',
  'block',
  'bloom',
  'blue',
  'boat',
  'bonus',
  'bottle',
  'box',
  'bread',
  'breeze',
  'brook',
  'bunny',
  'bush',
  'butterfly',
  'cake',
  'canary',
  'cell',
  'cherry',
  'clear',
  'clock',
  'cloud',
  'cookie',
  'coral',
  'cotton',
  'credit',
  'crocodile',
  'curry',
  'cyan',
  'daisy',
  'dance',
  'dandelion',
  'darkness',
  'dawn',
  'deep',
  'desert',
  'dew',
  'diamond',
  'dinosaur',
  'discovery',
  'disk',
  'dragon',
  'dream',
  'duck',
  'duke',
  'dusk',
  'dust',
  'eden',
  'experience',
  'explosion',
  'feather',
  'feelings',
  'field',
  'fiesta,',
  'fire',
  'firefly',
  'flamingo',
  'flow',
  'flower',
  'foam',
  'fog',
  'forest',
  'fox',
  'fresco',
  'frog',
  'frost',
  'fruitbat',
  'future',
  'gallery',
  'glade',
  'glass',
  'glitter',
  'glow',
  'goose',
  'grass',
  'green',
  'grey',
  'hall',
  'hamster',
  'hat',
  'haze',
  'heart',
  'hill',
  'ice',
  'igloo',
  'island',
  'jungle',
  'king',
  'lab',
  'lake',
  'leaf',
  'light',
  'lime',
  'limit',
  'lobster',
  'log',
  'love',
  'machine',
  'math',
  'meadow',
  'mist',
  'mode',
  'moon',
  'moose',
  'morning',
  'mountain',
  'mouse',
  'mud',
  'muse',
  'nation',
  'night',
  'nights',
  'oasis',
  'obscura',
  'ocean',
  'operation',
  'orchid',
  'owl',
  'paint',
  'panda',
  'pandemonium',
  'paper',
  'paradise',
  'pearl',
  'penguin',
  'perspective',
  'pine',
  'pirate',
  'pizza',
  'plank',
  'poetry',
  'pond',
  'powdered',
  'prince',
  'princess',
  'pura',
  'queen',
  'rain',
  'rainbow',
  'rapids',
  'recipe',
  'resonance',
  'revival',
  'rice',
  'river',
  'rocket',
  'rose',
  'salad',
  'scene',
  'sea',
  'shadow',
  'shape',
  'shark',
  'silence',
  'sky',
  'smoke',
  'snow',
  'snowflake',
  'sound',
  'space',
  'spaceship',
  'sparkle',
  'splash',
  'spoon',
  'spray',
  'spring',
  'squeeze',
  'star',
  'statue',
  'stroke',
  'sun',
  'sunset',
  'surf',
  'tango',
  'term',
  'thing',
  'thunder',
  'ticket',
  'tiger',
  'tint',
  'toast',
  'tooth',
  'toy',
  'tree',
  'trumpet',
  'truth',
  'umbrella',
  'union',
  'unit',
  'velvet',
  'verde',
  'view',
  'violet',
  'vitale',
  'voice',
  'void',
  'volcano',
  'vortex',
  'water',
  'waterfall',
  'waters',
  'wave',
  'weasel',
  'whisper',
  'wildflower',
  'wind',
  'window',
  'winter',
  'wish',
  'wizard',
  'wood',
  'woodpecker',
  'zing',
];
